import Lottie from 'react-lottie';
import animationData from './circle-loader.json';

type Props = {
  width?: number;
  height?: number;
  lottieJson?: any;
};

function CircleLoader(props: Props) {
  const { width = 40, height = 40, lottieJson } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieJson || animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Lottie
      options={defaultOptions}
      height={height}
      width={width}
    />
  );
}

export default CircleLoader;
